import { useCallback, useEffect, useMemo, useRef } from 'react';

// P7a (analiz §33 M73 "aktif düzenleme süresi") — form açıkken kullanıcının ETKİN çalıştığı süre (sn). Her etkileşim (tuş,
// giriş, tıklama) bir önceki etkileşimden IDLE_MS'ten kısa süre sonra gelirse aradaki süre eklenir; uzun boşluklar (başka sekme,
// toplantı) sayılmaz. Taslak üretimi değil, kullanıcının hazırlık işi ölçülür. Saf mantık `nextActiveMs`'te (test edilir).
export const IDLE_MS = 60_000;

export function nextActiveMs(totalMs, lastAt, now, idleMs = IDLE_MS) {
  if (lastAt == null) return totalMs;
  const gap = now - lastAt;
  return gap > 0 && gap <= idleMs ? totalMs + gap : totalMs;
}

export default function useActiveEditTimer(open) {
  const total = useRef(0);
  const last = useRef(null);

  useEffect(() => {
    total.current = 0;
    last.current = open ? Date.now() : null;
  }, [open]);

  const touch = useCallback(() => {
    const now = Date.now();
    total.current = nextActiveMs(total.current, last.current, now);
    last.current = now;
  }, []);

  const seconds = useCallback(() => Math.round(total.current / 1000), []);

  return useMemo(() => ({ touch, seconds }), [touch, seconds]);
}
